// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu[data-v-7005a5db] {\n  min-height: calc(100vh - 6.5rem - 2rem - 2rem);\n}", ""]);
// Exports
module.exports = exports;
